/**
 * Created by mkoehler on 16.05.22.
 */

export default class Image {
  constructor() {
    let _scope = this;
    this.headerimages = document.querySelectorAll('header > .image-wrapper');

    if (this.headerimages.length) {
      for (let headerimage of Array.from(this.headerimages)) {
        _scope.initHeader(headerimage);
      }
    }
  }

  initHeader (image) {
    let rows = document.querySelectorAll('main > .row');

    if(rows.length) {

      if(rows[0].classList.contains('bg-blue')) {
        image.classList.add('bg-blue');
      }

      if(rows[0].classList.contains('bg-lightgrey')) {
        image.classList.add('bg-lightgrey');
      }
    }
  }
}